/**
 * @author Fernando Ruano
 * @file index.js
 * @description PatientRegistration Container
 */

// Dependencies
import React from 'react';

// Components
import AppRoutes from '@nephro/components/AppRoutes';

// Routes
import routes from './routes';

/**
 * PatientRegistration Container.
 * @return { Node } React PatientRegistration container.
 */
const PatientRegistrationContainer = () => {
  return (
    <div className="h-full">
      <AppRoutes routes={routes} />
    </div>
  );
};

/**
 * @name PatientRegistration.propTypes
 * @type { Object }
 */
PatientRegistrationContainer.propTypes = {};

/**
 * Default props
 */
PatientRegistrationContainer.defaultProps = {};

export default PatientRegistrationContainer;
